import {WishlistIconName} from './iconNames';

export const wishlistPageIconAssets = {
  [WishlistIconName.Empty]: require('./assets/ic-empty-wishlist.svg'),
  [WishlistIconName.EmptyCompact]: require('./assets/ic-empty-wishlist-compact.svg'),
};
